import { call, put } from "redux-saga/effects";
import { toast } from "react-toastify";
import {
  getDefaultAccessFailure,
  getDefaultAccessSuccess,
  getStaffListFailure,
  getStaffListSuccess,
  getUserAccessListFailure,
  getUserAccessListSuccess,
  updateUserAccessFailure,
  updateUserAccessSuccess,
} from "../../Actions";
import { api } from "../../Config/ApiInterface";

// GET Staff List
function* getStaffListSaga(action) {
  try {
    const { page = 1, limit = 100, name = "" } = action.payload || {};
    const hotel_id=localStorage.getItem('hotel_id')
    const params = new URLSearchParams({ page, limit, name , hotel_id});

    const response = yield call(api.post, `/auth/staff?${params}`);
    if (response) {
      yield put(getStaffListSuccess(response.data));
    } else {
      yield put(
        getStaffListFailure(response.error || "Failed to fetch Staff list")
      );
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(getStaffListFailure(error));
    // toast.error("Failed to fetch Procurements.");
  }
}

function* getUserAccessSaga(action) {
  try {
    const { page = 1, limit = 100, name = "", id = "" } = action.payload || {};
    const params = new URLSearchParams({ page, limit, name, id });

    const response = yield call(api.post, `/auth/${id}/permissions`);
    if (response) {
      yield put(getUserAccessListSuccess(response.data));
    } else {
      yield put(
        getUserAccessListFailure(
          response.error || "Failed to fetch user access"
        )
      );
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(getUserAccessListFailure(error));
    // toast.error("Failed to fetch Procurements.");
  }
}

function* updateUserAccessSaga(action) {
  try {
    const { name = "", id = "" } = action.payload || {};
    const params = new URLSearchParams({ name});
    const response = yield call(
      api.patch,
      `/auth/staff/${id}/permissions`, // no id in the path
      action?.payload?.body,
      {
        // params: { staffId: action?.payload?.id }, // id as query param
      }
    );
    if (response) {
      yield put(updateUserAccessSuccess(response.data));
      toast.success(response?.data?.message)
    } else {
      yield put(
        updateUserAccessFailure(response.error || "Failed to fetch user access")
      );
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(updateUserAccessFailure(error));
  }
}

function* getDefaultAccessSaga(action) {
  try {
    const { name = "", id = "" } = action.payload || {};
    const params = new URLSearchParams({ name, id });
    const response = yield call(
      api.post,
      `/auth/staff/default/${id}`, // no id in the path
      action?.payload?.body,
      // {
      //   params: { role: action?.payload?.id }, // id as query param
      // }
    );
    if (response) {
      yield put(getDefaultAccessSuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        getDefaultAccessFailure(response.error || "Failed to fetch default access")
      );
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(getDefaultAccessFailure(error));
  }
}

export {
  getStaffListSaga,
  getUserAccessSaga,
  updateUserAccessSaga,
  getDefaultAccessSaga,
};
